import React from 'react';
import ShoppingCart from '../../utils/shoppingCart';
import Button from '../common/Button';

const EmptyCartButton = props => {
  return (
    <Button
      className="w-full "
      iconClass="fas fa-trash"
      onClick={() => {
        ShoppingCart.emptyShoppingCart();
        props.onEmptyCart();
      }}>
      Vaciar carrito
    </Button>
  );
};

export default EmptyCartButton;
